// extracted by mini-css-extract-plugin
export default {"watchlistsPopupHeader":"WatchlistPopupHeader_watchlistsPopupHeader__gOB7N","headerText":"WatchlistPopupHeader_headerText__AyMbW","closeIcon":"WatchlistPopupHeader_closeIcon__oiwWX"};